/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import $ from 'jquery';
import _ from 'underscore';
import Config from './Config.js';

const QUERY_ITEM = 'QueryItem';
const CALCULATION = 'Calculation';
class RelationshipDndHelper{

	constructor(domNode, className, dropHandler, acceptsHandler , dragEnterHandler, dragLeaveHandler, relationshipVM) {
		this.domNode = domNode;
		this.className = className;
		this.dropHandler = dropHandler;
		this.acceptsHandler = acceptsHandler;
		this.dragEnterHandler = dragEnterHandler;
		this.dragLeaveHandler = dragLeaveHandler;
		this.relationshipVM = relationshipVM;
	}

	accepts(dragObject) {
		const data = this.getData(dragObject);
		if(data && data.length){
			const targetModel = this.relationshipVM.getTargetModel();
			const nodeCount = targetModel.getDiagramNodeCount();
			if (!nodeCount || (data.length + nodeCount > Config.max_nodes_to_display)) {
				// can't add fields if nothing in diagram or total of nodes in diagram after the drop could be bigger than the limit of number of nodes to display
				return false;
			}
			const invalidObjectType = data.some((entry) => {
				// if at least one object is not a query item/calculation, do not accept the drop
				if (!entry.getObjectType || (entry.getObjectType() !== QUERY_ITEM && entry.getObjectType() !== CALCULATION)) {
					return true;
				}
			});
			return (!invalidObjectType);
		}
		return false;
	}

	getData(dragObject) {
		return this._getDropMetadataColumns(dragObject);
	}

	_getDropMetadataColumns(dragObject) {
		return _.map(dragObject && dragObject.data && dragObject.data.columns, (column) => column.metadataColumn);
	}

	activateDropTarget() {
		$(this.domNode).toggleClass(this.className, true);
	}

	deactivateDropTarget() {
		$(this.domNode).toggleClass(this.className, false);
	}

	onDragStart() {
	}

	onDragEnter(dragObject, dropNode) {
		this.dragEnterHandler(dragObject, dropNode);
	}

	onDragMove() {
		this.activateDropTarget();
	}

	onDragLeave() {
		this.deactivateDropTarget();
		this.dragLeaveHandler();
	}

	onDragEnd() {
		this.deactivateDropTarget();
	}

	onDrop(dragObject, dropNode) {
		this.dropHandler(dragObject, dropNode);
	}

	initializeDndSource(dndManager) {
		$(this.domNode).on('mousedown touchstart', {}, (event) => {
			const $avatar = $('<div style="position:absolute; z-index:10000;"/>', {
				'class': 'listitem columnName avatarLive'
			});
			$avatar.append($(this.domNode).clone());
			dndManager.startDrag({
				event: event,
				avatar: $avatar,
				moveXThreshold: 20,
				moveYThreshold: 20
			});
			return true;
		});
	}
}

export default RelationshipDndHelper;



// WEBPACK FOOTER //
// ./src/js/components/startingPoints/relationshipGraph/RelationshipDnDHelper.js